import { combineReducers } from 'redux';
import { combineActions, handleAction } from 'redux-actions';
import {
  AnyObject,
  InvestmentListsState,
  InvestmentPageKey,
  InvestmentsState,
  RootState
} from '../../../types';
import investmentsActions from './actions';

const byIdReducer = handleAction<AnyObject, any>(
  combineActions(investmentsActions.fetchInvestmentSuccess),
  (state, action) => ({
    ...state,
    [action.payload.id]: action.payload.data
  }),
  {}
);

const pagesReducer = handleAction<AnyObject, any>(
  investmentsActions.fetchInvestmentPageSuccess.toString(),
  (state, action) => ({
    ...state,
    [action.payload.id]: action.payload.data
  }),
  {}
);

const listsReducer = handleAction<InvestmentListsState, any>(
  investmentsActions.fetchInvestmentsSuccess.toString(),
  (state, action) => {
    const { list, ...restPageData } = action.payload.pageData;
    const { page, ...restParams } = action.payload.params;
    return {
      byPage: {
        ...state.byPage,
        [page]: { list, ...restParams }
      },
      pageData: restPageData
    };
  },
  {
    byPage: {},
    pageData: null
  }
);

export default combineReducers<InvestmentsState>({
  byId: byIdReducer,
  pages: pagesReducer,
  lists: listsReducer
});

export const getInvestmentsHomePageInfo = (state: RootState) =>
  state.app.investments.lists.pageData;
export const getInvestmentsHomePageList = (page: InvestmentPageKey) => (
  state: RootState
) => state.app.investments.lists.byPage[page];
export const getInvestmentInfo = (id: string) => (state: RootState) =>
  state.app.investments.byId[id];
export const getInvestmentsPageInfo = (id: string) => (state: RootState) =>
  state.app.investments.pages[id];
